<br>
<div class="container" *ngIf="tabs">
  <mat-tab-group>
    <mat-tab *ngFor="let n of tabs; let i = index" [label]="n.name">
      <app-record-table
      [data]="n.data"
      [index]="i"
      [displayedColumns]="n.columns"
      [headerTxt]="n.headerTxt"
      [pageSizeOptions]="n.pageSizeOptions"
      [selectedDates]="n.dateRange"
      [downloading]="n.downloading"
      [downloadErr]="n.downloadErr"
      (dates)="onSearchBtnClick($event)"
      (recs)="updateRecs($event)">
      </app-record-table>
    </mat-tab>
  </mat-tab-group>
</div>
